import {makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {type ICountryProvider} from "data/providers/country/country.provider";
import {SquadUtils} from "data/utils/squad";
import {DISABLE_COUNTRY_CHECK, ODDS_DISABLED} from "data/constants";

export interface ICountryStore {
	get isAllowed(): boolean;

	fetch(): Promise<void>;
}

@injectable()
export class CountryStore implements ICountryStore {
	@observable _isAllowed = false;
	constructor(@inject(Bindings.CountryProvider) private _countryProvider: ICountryProvider) {
		makeAutoObservable(this);
	}

	get isAllowed(): boolean {
		if (ODDS_DISABLED) {
			return false;
		}

		if (DISABLE_COUNTRY_CHECK) {
			return true;
		}

		return this._isAllowed && !SquadUtils.SELECTED_SQUAD;
	}

	fetch(): Promise<void> {
		return this._countryProvider.check().then((result) => {
			runInAction(() => {
				this._isAllowed = result.data.success.ifAllowed;
			});
		});
	}
}
